import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animal-products',
  templateUrl: './animal-products.component.html',
  styleUrls: ['./animal-products.component.css']
})
export class AnimalProductsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
